<template>
  <div class="not-found">
    <el-row type="flex" justify="center" align="middle" style="height: 100vh">
      <el-col :span="12">
        <div class="not-found-content">
          <img src="../assets/images/404.png" alt="">
          <h1>404 - 页面未找到</h1>
          <p>您访问的页面不存在，请检查网址是否正确。</p>
          <el-button type="primary" @click="goBack">Return</el-button>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
	data(){
		return{
			imgUrl:'./assets/images/404.png'
		}
	},
	methods: {
    goBack() {
      this.$router.push('/');
    },
  },
  
};
</script>

<style lang="less" scoped>
.not-found {
  text-align: center;
}

.not-found-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

h1 {
  font-size: 24px;
  margin-bottom: 10px;
}

p {
  font-size: 16px;
  margin-bottom: 20px;
}
</style>